import { List } from '../objects/list';
import { Locale } from '../objects/locale';

export const SET_CURRENT_LOCALE = 'LOCALE_SET_CURRENT_LOCALE';
export const SET_LIST = 'LOCALE_SET_LIST';
export const SET_LIST_LOCALE = 'LOCALE_SET_LIST_LOCALE';
export const SET_MAIN_LOCALE = 'LOCALE_SET_MAIN_LOCALE';
export const SET_TRANSLATE_LOCALE = 'LOCALE_SET_TRANSLATE_LOCALE';

interface SetCurrentLocaleAction {
    type: typeof SET_CURRENT_LOCALE,
    payload: number
}

interface SetListAction {
    type: typeof SET_LIST,
    payload: Locale[]
}

interface SetListLocalesAction {
    type: typeof SET_LIST_LOCALE,
    payload: List
}


interface SetMainLocaleAction {
    type: typeof SET_MAIN_LOCALE,
    payload: number
}

interface SetTranslateLocaleAction {
    type: typeof SET_TRANSLATE_LOCALE,
    payload: number[]
}

export type LocaleActionTypes =
    SetCurrentLocaleAction |
    SetListAction |
    SetMainLocaleAction |
    SetTranslateLocaleAction |
    SetListLocalesAction;